import styled, { css } from 'styled-components';

export const FlightSearchBarWrapper = styled.div<{
  isListingPage?: boolean;
}>`
  width: 100%;

  ${({ isListingPage }) =>
    isListingPage &&
    css`
      ${({ theme }) => theme.mediaQueries.LARGE_1X_UP} {
        padding: 24px 0px;
      }
    `}
`;

export const FlightSearchBarInnerWrapper = styled.div``;

export const FlightSearchBarBodyWrapper = styled.div`
  margin-top: 12px;

  ${({ theme }) => theme.mediaQueries.LARGE_1X_UP} {
    margin-top: 24px;
  }
`;

export const StyledContent = styled.div<{ $alignVertical?: boolean }>`
  display: flex;
  justify-content: flex-start;

  flex-direction: ${({ $alignVertical }) =>
    $alignVertical ? 'column' : 'row'};

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    flex-direction: column;
  }
`;

export const DatepickerWrapper = styled.div<{ $alignVertical?: boolean }>`
  margin: 0 8px;

  margin: ${({ $alignVertical }) => ($alignVertical ? '12px 0' : '0 8px')};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin: 0px;
    margin-bottom: 12px;
    margin-top: 12px;
  }
`;

export const ButtonWrapper = styled.div<{
  isListingPage?: boolean;
  $alignVertical?: boolean;
}>`
  margin: ${({ $alignVertical }) =>
    $alignVertical ? '12px 0px' : '0px 0px 0px 8px'};

  width: ${({ $alignVertical }) => ($alignVertical ? '100%' : '150px')};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin: 12px 0px;
    width: 100%;
  }
`;

export const GuestBoxWrapper = styled.div<{ $alignVertical?: boolean }>`
  width: ${({ $alignVertical }) => ($alignVertical ? '100%' : '250px')};

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
  }
`;

export const ListingSearchbarWrapper = styled.div`
  gap: 24px;
  display: flex;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    flex-direction: row;
  }
`;
export const ListingGuestBox = styled.div`
  width: 150px;
  margin: 0px 0px 0px 24px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
  }
`;
